/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AddToChallengeBody from "components/CRMComponents/CRMLeadInformationComponents/CRMLeadAddToChallenge/AddToChallengeBody";

const CRMLeadAddToChallenge = () => {
  useEffect(() => {
    document.title = "CRM Lead |  Add to Challenge";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <AddToChallengeBody />
    </main>
  );
};

export default CRMLeadAddToChallenge;
